<template lang="pug">
.generic-card(:style="sizeString")
  .card.shadow.d-flex.flex-column(
    :class='innerCardStyle'
  )
    slot
</template>

<script>
export default {
  computed: {
    sizeString() {
      const intendedFullWidth = 1024; // Given width of iPad when landscape as a baseline
      const intendedSmallestWidth = 960; // Given width of normal grid in web as a baseline
      if (this.size === 'auto') {
        return 'flex: 1';
      }

      const width = `${this.size}${this.unit}`;

      let sizeString = `
        width: ${width};
      `;

      if (this.unit === 'vw') {
        const minWidth = intendedSmallestWidth * (this.size / 100);
        const maxWidth = intendedFullWidth * (this.size / 100);

        sizeString += `min-width: ${minWidth}px;\n`;
        // if set to true, the card will be allowed to expand
        if (this.ignoreMaxWidth === false) {
          sizeString += `max-width: ${maxWidth}px;\n`;
        }
      }
      return sizeString;
    },

    innerCardStyle() {
      let style = '';
      if (this.h100) {
        style += ' h-100';
      }
      if (this.scrollable) {
        style += ' scrollable';
      }
      return style;
      // return {
      //   'h-100': this.h100 === true,
      //   'scrollable': this.scrollable === true,
      // };
    },
  },
  props: {
    unit: {
      default: 'vw',
    },
    size: {
      type: String,
      default: '33',
      // validator(val) { // must return true
      //   return [
      //     'auto',
      //     '25', '50', '75', '100',
      //     '33', '66',
      //     '40', '80',
      //     '27', '30',
      //   ].indexOf(val) !== -1;
      // },
    },
    ignoreMaxWidth: {
      default: false,
    },
    h100: {
      default: false,
    },
    scrollable: {
      default: false,
    },
  },
};
</script>

<style lang="scss">
.generic-card {
  padding: 24px;
  flex-shrink: 0;
  min-width: 320px;
  .card {
    min-height: 48px;
    border: none;
    overflow-x: hidden !important;

    .card-title {
      font-size: 17px;
    }
    .card-section-title {
      font-size: 21px;
    }
  }

}
</style>
